import React, { Component } from "react";

import Header from "../components/header";
import Banner from "../components/banner";
import Footer from "../components/footer";
import InfoCard from "../components/InfoCard";
// import JoinPortal from "../components/JoinPortal";
// import SiteSlide from "../components/siteSlide";
import Form from "../components/form";
import Modal from "../components/modal";
class Home extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      activeIndex: null
    };
  }
  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

 

  toggleAccordion = (index) => {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? null : index,
    }));
  };


  render() {
    const { showModal } = this.state;

    const faqData = [
      {
        question: "Considering past experiences as regards to fraudulent practices of somehow similar platforms, why should the wealth system be trusted? ",
        answer:
          "The wealth system is entirely people centric. It is designed  empower the society. The system has physical offices and is also designed, developed and managed by a reputable company registered with CAC in Nigeria",
      },
      {
        question: "From the reward table as published, the figures are huge and over tempting, thus raises doubt on the system's capacity to fulfill its financial obligations to users without going bankrupt in the nearest future. Should one not be skeptical?   ",
        answer:
          "To a non financial expert or a non mathematician, the figures might be huge. However, it’s just a fraction of what your task performance gave the system. The system is only giving out almost what it gets from the society, leaving little for system maintenance and upgrade, hence 40% referral bonus. It is a self sustaining system that can never go bankrupt because every considerations were made before it’s development by team of best brains.  ",
      },
      {
        question: "From experience, cash out has always been an issue after earning through task performance in most platforms. How is one sure that the same will not happen here? ",
        answer:
          "The system reduced it’s minimal withdrawal threshold to N5000 so as to allow users test the efficiency of the payout mechanism and decide on staying with the system or exiting. Anyways, the payout is guaranteed. ",
      },
      {
        question: "Is the system hack free? ",
        answer:
          "The system’s security is top notch, hence has a secured backend. The users have to make it more secured by creating a strong password upon signup and safeguard it too. Users should also activate the two factor authentication protocol to enable the system verify every payout request before approval. ",
      },
      {
        question: "Is the loan not a scam designed to attract users into the platform since it does not require collateral? ",
        answer:
          "It’s unfortunate that every good thing is seen wrongly. The system continues to reward users after they have finished performing their task to an unlimited amount. The loan is like an overdraft which shall have a negative effect on the users wallet balance and shall automatically be written off as more money is earned, hence does not require collateral. ",
      },
      {
        question:"Why is it mandatory that whoever the system has rewarded above twenty million naira should establish a business that is capable of employing not less than three persons and upload evidence or face account suspension? ",
        answer:" We are in a society where people like receiving but hate giving back. The clause is to encourage system beneficiaries appreciate the society from where their wealth came, though facilitated by the system. Moreover, viable business establishment helps solidifies wealth and makes sure no empowered user goes bankrupt after testing wealth.  "
      }
    ];

    return (
      <div>
        <Header />
        <Banner />
        {/* ABOUT WealthSystem */}
        <div className="our-team-content" >
          <div >
          <h4>Place your advert here:</h4>
            <div className="underline"></div>
            <p>
              Reach your audience effectively by placing your advert here. Gain visibility and connect 
              with a wider network through our platform.
            </p>
            <p>
              <a href="mailto:admin@wealthsystem.net">admin@wealthsystem.net</a> | 
              <a href="mailto:support@wealthsystem.net"> support@wealthsystem.net</a>
            </p>
            </div>

        </div>

        <div className="welcome" style={{backgroundColor: "antiquewhite"}}>
          <div className="container">
            <p style={{ paddingTop: "100px" }}></p>
      <div className="text-center"> 
             <h3 className="" style={{fontWeight:"800"}}> Welcome to The Wealth System </h3>
              
        
            <div className="site-text-color pb-4" style={{marginTop:"-5px",fontSize:"18px"}}>
            Transform Your Efforts into Limitless Wealth
            </div>
          
            <label className="text-left" style={{ textAlign: "justify" }}>
            The Wealth System is a revolutionary investment platform designed to empower wealth cultivators with sustainable financial growth. Created by a team of renowned financial experts. Our system leverages key investment inputs—time, persuasion, data, and access fees—to create a self-sustaining ecosystem that rewards dedication and effort.
Unlike platforms that promise unrealistic returns without work, The Wealth System ensures that every earning is backed by real tasks, referrals, and internal revenue streams such as investment realm access fees, advertisement placements, and in-system games.
These are what we offer:
            <br></br>
            </label>
        </div>

        <div className="pt-5 pb-5" style={{ textAlign: "justify" }}>
              <div className="row">
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm.jpg"
                    title="Task-Based Earnings – No Risk, Just Rewards"
                    content="Unlike traditional investment platforms that rely on speculation, The Wealth System ensures that all earnings are backed by tasks and contributions."
                    color="#2769ce"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="ext1.jpg"
                    title="Exclusive Referral & Earning Structure"
                    content="Our system ensures sustainable wealth creation through a carefully designed referral program. You earn commissions up to 5 downline levels, meaning your network’s growth directly impacts your earnings."
                    color="#4ba86b"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm1.jpg"
                    title="Free Interest Loan"
                    content="We believe in helping our users grow without financial burdens. Once you reach the 6th Investment Realm, you are eligible for a one-time, interest-free loan of up to 50% of your unwithdrawn earnings. 
                    (i.) No interest or hidden charges. (ii.) Recovered from future cultivation rewards.
This means you can access funds for urgent needs without worrying about repayment stress."
                    color="#ca8125"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm2.jpg"
                    title="Online Skills Acquisition & Business Grants"
                    content="You gain access to exclusive online training programs designed to equip you with valuable skills for long-term success. Gain 📚 Professional skill training in various fields
💰 Startup capital for successful trainees (grants for those scoring 60% and above in assessments)
🤝 Business partnerships for high-reward users."
                    color="#37a49f"
                  />
                </div>
               
              </div>
            </div>

   
            </div>
            <br></br>
       
        </div>

        <div className=" ext2 bg-image " >
          <div className="location pt-5 aboutInfo  container-fluid">
            <div>
              <p style={{ paddingTop: "50px" }}></p>

              <div
                className="text-warning"
                style={{
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                Why Choose The Wealth System?
                
              </div>
              <label
                className=" text-light d-block" 
                style={{ textAlign: "center", marginTop:"0px"}}
              >
               What Awaits You:
              </label>
            </div>

            <div className="pane pt-5 pb-5" style={{ textAlign: "justify" }}>
              <div className="row">
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm.jpg"
                    title="A Clear Roadmap to Financial Success"
                    content="We believe that financial success should not be left to chance. The Wealth System offers a step-by-step roadmap that guides you from the 1st Investment Realm to the 12th Investment Realm, each with increasing financial rewards and exclusive benefits. As users complete their tasks and progress through the levels, they unlock interest-free loans, skill acquisition programs, and business grants, paving the way for long-term financial freedom."
                    color ="#101316c2"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm1.jpg"
                    title="A Transparent, Structured, and Rewarding System"
                    content="At The Wealth System, transparency is at the core of everything we do. Every reward is calculated based on tangible inputs, ensuring that users understand how they earn. Our structured approach allows participants to move through different Investment Realms, performing tasks, inviting referrals, and unlocking greater financial benefits as they progress. This structured growth model guarantees sustainable wealth creation for all committed users."
                    color ="#101316c2"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="grm2.jpg"
                    title="No Hidden Fees, Scams, or Unrealistic Promises"
                    content="Many investment platforms fail because they make outrageous promises that cannot be sustained. The Wealth System is not a Ponzi scheme; it is a real, task-based system where rewards are earned through actual work. Our revenue model is self-sustaining, funded by investment access fees, advertising revenue, and in-system activities, ensuring that users' earnings are backed by real financial sources."
                    color ="#101316c2"
                  />
                </div>
                <div
                  className="col-lg-6  pe-3 px-3 pb-4 "
                  style={{ fontSize: "20px" }}
                >
                  <InfoCard
                    img="ext1.jpg"
                    title="Opportunities for Long-Term Business Growth"
                    content="Beyond financial rewards, The Wealth System provides users with the tools and resources to build sustainable businesses. Participants who achieve high earnings (over ₦20 million or its equivalent in dollars) are required to invest in businesses that create jobs, ensuring that the wealth generated contributes to economic growth. Additionally, successful cultivators are eligible for business grants, partnerships, and training programs, equipping them with the skills to become industry leaders."
                    color ="#101316c2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <JoinPortal /> */}

        <div className="our-team-content">
          <h2>OUR SYSTEM TEAM</h2>
          <div className="underline"></div>
          <p>
            Our dedicated support team works 24/7, making sure that user&apos;s needs are met 
            in real time. Mails are discretely handled, and doubts are also cleared through 
            our comprehensive approach to problem-solving and clear-cut answers to 
            questions. Get help and support from the team and also feel very free to inform 
            us of any issue that you feel requires proper analysis via any of our emails:  
          </p>
          <p>
            <a href="mailto:admin@wealthsystem.net">admin@wealthsystem.net</a> | 
            <a href="mailto:support@wealthsystem.net"> support@wealthsystem.net</a>
          </p>
          
        </div>

        <div className=" ext2  ">
          <div className="location pt-5 aboutInfo  container-fluid">
            <div>
              <p style={{ paddingTop: "50px" }}></p>

              <div
                className="text-warning"
                style={{
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                Frequently Asked Questions
                
              </div>
              <label
                className=" text-light d-block" 
                style={{ textAlign: "center", marginTop:"0px"}}
              >
                           <p>Find answers to the most common questions about our system.</p>
              </label>
            </div>


            <div className="pane pt-5 pb-5" style={{ textAlign: "justify" }}>
              <div className="row">
                {/* Left Side: FAQ Accordion */}
                <div className="col-lg-8">
                  <div className="accordion border-2" style={{ backgroundColor: "#ffffff0d" }}>
                    {faqData.map((item, index) => (
                      <div
                        key={index}
                        className={`accordion-item p-4 ${this.state.activeIndex === index ? "active" : ""}`}
                        style={{
                          backgroundColor: "#ffffff0d",
                          borderTop: "none",
                          borderLeft: "none",
                          borderRight: "none",
                          borderBottom: "5px solid #ffffff0d"
                        }}
                      >
                        <button className="accordion-header text-light" onClick={() => this.toggleAccordion(index)}>
                          <b style={{ fontSize: "20px" }}>{item.question}</b>
                          <span className="arrow">
                            {this.state.activeIndex === index ? "▲" : "▼"}
                          </span>
                        </button>
                        <div
                          className="accordion-content text-light"
                          style={{
                            maxHeight: this.state.activeIndex === index ? "800px" : "0px",
                          }}
                        >
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Side: FAQ Images */}
                <div className="col-lg-4">
                  <div className="faq-ri">
                    <div className="image--1"></div>
                    <div className="image--2"></div>
                    <div className="image--3"></div>
                  </div>
                </div>
              </div>
            </div>
</div>
</div>
        <Modal
          title="Join Community"
          showModal={showModal}
          toggleModal={this.toggleModal}
          content={<Form toggleModal={this.toggleModal} />}
        />
        <Footer />
      </div>
    );
  }
}

export default Home;
